
define('text!areas/aaaprovisioning/views/index.html',[],function () { return '<div>\r\n</div>';});

